export const REST_ERROR_KIND = {
  HTTP: 'http',
  NETWORK: 'network',
  TIMEOUT: 'timeout',
  ABORTED: 'aborted',
};

export class RestError extends Error {
  constructor({ kind, message, status = null, grpcCode = null, details = [], retryAfterSec = null, cause = null }) {
    super(message || kind);
    this.name = 'RestError';
    this.kind = kind;
    this.status = status;
    this.grpcCode = grpcCode;
    this.details = details;
    this.retryAfterSec = retryAfterSec;
    this.cause = cause;
  }
}

// Nhận diện bằng `name` chứ không phải instanceof: class kế thừa Error qua Babel có thể mất
// prototype chain tuỳ target build, khi đó instanceof trả false dù đúng là RestError.
export const isRestError = (error) => error?.name === 'RestError' && typeof error?.kind === 'string';
